import { GetPointResponse, GetTopicResponse } from '../../types';

import { State } from '../state/state-management/state';
import { getQueryStringParameters } from '../urls';
import { setFavicon } from '../utils';

class SeoData extends State {

  static amplitude_callsite: string = 'SEO Data';

  // call this at the top of any page that needs seo data
  async instantiateSeoData(amplitudeCallsite: string, isAuthenticated: boolean, topicIsReady: boolean, topic: GetTopicResponse, points: GetPointResponse[]) {
    const queryString = getQueryStringParameters();
    const topicId = queryString.get('topic_id');

    if (topicId === undefined) {
      window.location.assign('/#404');
    }

	}

  async setPageTitle(amplitudeCallsite: string, topic: GetTopicResponse) {
    try {
      // SEO
      // if page url contains #admin-portal, set title to admin portal
      switch (amplitudeCallsite) {
          case 'Admin Portal':
              document.title = 'Edit: ' + topic.name;
              break;
          case 'discover-details':
              document.title = topic.name + ': Interactive Guide';
              break;
          case 'Printable Map':
              document.title = 'Printable: ' + topic.name;
              break;
          case 'Map Page':
              document.title = topic.name + ': Map';
              break;
          default:
              document.title = topic.name;
      }

      // get first topic category with an icon that starts with http
      const categoryWithIcon = topic.categories.find((category) => {
          return category.icon?.startsWith('http');
      });

      setFavicon(categoryWithIcon?.icon ?? '');
    } catch (e: any) {
    }

  }


}

const seoData = new SeoData();

export default seoData;

